// extracted by mini-css-extract-plugin
module.exports = {"sub-title":"V-4-r","subTitle":"V-4-r","spacer-20":"bCQkS","spacer20":"bCQkS","quantity":"_15y6k"};